export default __webpack_public_path__ + "images/union-stone-4.svg";